var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Square_Envirotainer_Turquoise_Warehouse",
    transform: "matrix(1.25,0,0,1.25,-140,-140)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Warehouse_Path",
    fill: "#FFFFFF",
    d: "M316.7,135l-194.3,86.3v275.5h66.1h33.4c0.3,0.1,0.6,0.2,0.9,0.2H327 c0.4,0.2,0.8,0.1,1.1-0.2h30.2c0.3,0.1,0.6,0.2,0.9,0.2h50c0.3,0,0.6-0.1,0.9-0.2h34.6h2.1h63.9V221.3L316.7,135z M444.6,278.3 v126.2h-32.1c-0.9-6.3,3.3-64-2.7-61.4h-98.9c-1.6,0-2.9,1.3-2.9,2.9c1.2,1.4-2,45.6,0.6,58.5h-31.8v-67.4c3.4-6-53.1-1.6-54.3-2.9 c-1.6,0-2.9,1.3-2.9,2.9c1.3,1.4-2.2,53.3,0.7,67.4h-31.9V278.3H444.6z M412,491v-53c0-1.6-1.3-2.9-2.9-2.9h-50 c-1.6,0-2.9,1.3-2.9,2.9v53h-26.6c1.7-14.8-0.9-51.3,0.2-52.2c0-1.6-1.3-2.9-2.9-2.9H222.8c-1.6,0-2.9,1.3-2.9,2.9V491h-31.4v-83.1 h256.1V491H412z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.e13bda5179321c0bafbf8a6eaf15f508.svg";
export { ForwardRef as ReactComponent };